import React from 'react';
import { isUndefined } from 'lodash';
import Help from '../Help';

const CroSubhead = ({ title, helpEnum, tooltipPosition, style, disabled }) => (
  <div className="sub-head">
    <div className="text" style={style}>{title}</div>
    {!isUndefined(helpEnum) && <span style={{ marginLeft: -30, height: '70%' }}>
      <Help helpEnum={helpEnum} tooltipPosition={tooltipPosition} disabled={disabled} />
    </span>}
  </div>
);

export default CroSubhead;